import AbsenceProjection from './AbsenceProjection';

export default AbsenceProjection;